import { Component, Input, input } from '@angular/core';
import { GuidanceService } from '../providers/guidance.service';

@Component({
    selector: 'app-guidance',
    templateUrl: './guidance.component.html',
    styles: ``,
    standalone: false,
})
export class GuidanceComponent {
    @Input()
    public resource: string = '';

    @Input()
    public width: string = null;

    @Input()
    public tooltip: string = 'Clic para más información';

    public constructor(private _guidance: GuidanceService) {}

    public onContextualizeGuidance(): void {
        this._guidance.contextualize({
            resource: this.resource,
            width: this.width,
        });
    }
}
